import { render, staticRenderFns } from "./context-tab.vue?vue&type=template&id=90fc500e&scoped=true"
import script from "./context-tab.vue?vue&type=script&lang=js"
export * from "./context-tab.vue?vue&type=script&lang=js"
import style0 from "./context-tab.vue?vue&type=style&index=0&id=90fc500e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fc500e",
  null
  
)

export default component.exports